import { Skeleton } from "antd";
import moment from "moment/moment";
import React from "react";
import { useChatMessageStore } from "../store";
import ChatTabItem from "./ChatTabItem";

export default function ChatTab({ isLoading, lastMessages, userProfile, updateSeenMutation }) {

  return (
    <div
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {isLoading && (
          <div style={{ padding: "12px 16px" }}>
            {new Array(5).fill(null).map(() => <Skeleton avatar paragraph={{ rows: 1 }} />)}
          </div>
        )}
        {(lastMessages || []).map((lastMessage, index) => {
          return (
            <ChatTabItem
              lastMessage={lastMessage}
              userProfile={userProfile}
              updateSeenMutation={updateSeenMutation}
            />
          );
        })}
      </div>
    </div>
  );
}